import Backbone from 'backbone';

const $ = Backbone.$;

export default {
  run(editor, sender, opts = {}) {
    sender && sender.set && sender.set('active', 0);
    var command_type = sender.get('command');
    switch (command_type) {
      case 'show-sidebar':
        editor.ControlManager.openConrolList();
        break;
      case 'studio-export':
        editor.studioPlugin.export();
        break;
      case 'add-new-control':
        editor.studioPlugin.addControl();
        break;
      case 'edit-control':
        editor.studioPlugin.editControl();
        break;
      case 'save-control':
        editor.studioPlugin.saveControl();
        break;
      default:
        break;
    }
  }
};
